import i18n, { LanguageObject } from '@/i18n';
import { SurveyGroup, SurveyParticipation } from './SurveyUtils';
import axios from 'axios';

interface Worksheet {
  id: number;
  name: LanguageObject;
  active: boolean;
  surveygroup: Partial<SurveyGroup>;
  layout: {
    headers: Partial<WorksheetHeader>[];
  };
}

interface WorksheetHeader {
  name: LanguageObject;
  question: {
    key: string;
  };
}

interface WorksheetResult {
  answers: {
    answer: WorksheetAnswer;
    columnname: LanguageObject;
    questionkey: string;
  }[];
  participation: Partial<SurveyParticipation>;
}

interface WorksheetAnswer {
  displaytype: 'text' | 'count' | 'suborg' | 'clientele';
  questionid: number;
  [key: string]: any;
}

const api = {
  list: async (params?: { surveygroupid: number }) => {
    const resp = await axios.get<Worksheet[]>('/workSheet/list.php', {
      params: params,
    });
    return resp.data;
  },

  get: async (id: number) => {
    const resp = await axios.get<Worksheet>('/workSheet/get.php', {
      params: { id: id },
    });
    return resp.data;
  },

  view: async (id: number) => {
    const resp = await axios.get<WorksheetResult[]>('/workSheet/view.php', {
      params: { id: id, language: i18n.locale },
    });
    return resp.data;
  },

  add: async (worksheet: Partial<Worksheet>) => {
    const resp = await axios.post<{ id: number }>(
      '/workSheet/add.php',
      worksheet
    );

    return {
      ...worksheet,
      id: resp.data.id,
    } as Worksheet;
  },

  update: async (worksheet: Partial<Worksheet>) => {
    const resp = await axios.post('/workSheet/update.php', worksheet);
    return resp.data;
  },

  remove: async (id: number) => {
    const resp = await axios.delete('/workSheet/delete.php', {
      params: { id: id },
    });
    return resp.data;
  },

  listQuestions: async (params?: { surveygroupid: number }) => {
    const resp = await axios.get<WorksheetHeader['question'][]>(
      '/workSheet/listQuestions.php',
      {
        params: params,
      }
    );
    return resp.data;
  },
};

export default {
  api: api,
};
export { Worksheet, WorksheetHeader, WorksheetResult };
